import { z } from "zod"
import {
  NotificationListSchema,
  PushMsgListSchema,
} from "./notification.schema"

export enum NotificationKindEnum {
  ProjectInvoiceAdded = "ProjectInvoiceAdded",
  CommentCreated = "CommentCreated",
  CommentResolved = "CommentResolved",
  CATWorkflowAssigned = "CATWorkflowAssigned",
}

export type PushMsgList = z.infer<typeof PushMsgListSchema>
export type NotificationList = z.infer<typeof NotificationListSchema>
